import { cn } from "../lib/utils";

interface TogglePillGroupProps<T extends string> {
  value: T;
  onChange: (value: T) => void;
  options: { value: T; label: string }[];
  className?: string;
}

export function TogglePillGroup<T extends string>({
  value,
  onChange,
  options,
  className,
}: TogglePillGroupProps<T>) {
  return (
    <div className={cn("flex items-center gap-1 rounded-full border border-border p-1", className)}>
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => onChange(option.value)}
          className={cn(
            "rounded-full px-3 py-1 text-xs font-medium transition-colors",
            value === option.value
              ? "bg-primary text-primary-foreground"
              : "text-muted-foreground hover:text-foreground",
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
